/* ZwierzŚwiat storefront: add to cart, bundles, gallery, sticky buy bar, checkout consent. */
(() => {
  const routes = window.routes || {};
  const cartAddUrl = (routes.cart_add_url || '/cart/add') + '.js';
  const cartUrl = routes.cart_url || '/cart';

  // Remove items in the other language (one cart is shared by the PL and EN markets).
  const cleanup = (async () => {
    const keys = window.zsForeignCartKeys || [];
    if (!keys.length) return;
    const updates = Object.fromEntries(keys.map((k) => [k, 0]));
    try {
      await fetch((routes.cart_update_url || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      window.location.reload();
    } catch (e) {}
  })();

  async function addItems(ids) {
    await cleanup;
    const items = ids.map((id) => ({ id: Number(id), quantity: 1 }));
    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!response.ok) throw new Error('cart/add failed: ' + response.status);
  }

  function bindSubmit(form, getIds) {
    form.addEventListener('submit', async (event) => {
      const ids = getIds();
      if (!ids.length) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const error = form.querySelector('[data-zs-error]');
      const label = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        if (button.dataset.adding) button.textContent = button.dataset.adding;
      }
      if (error) error.hidden = true;
      try {
        await addItems(ids);
        if (form.hasAttribute('data-zs-stay')) window.location.reload();
        else window.location.assign(form.dataset.zsNext || cartUrl);
      } catch (e) {
        if (button) {
          button.disabled = false;
          button.textContent = label;
        }
        if (error) error.hidden = false;
        else form.submit();
      }
    });
  }

  // Single product forms (cards, upsell).
  document.querySelectorAll('form[data-zs-add]').forEach((form) => {
    bindSubmit(form, () => [form.querySelector('input[name="id"]').value]);
  });

  // Bundle cards: several products at once.
  document.querySelectorAll('form[data-zs-multi]').forEach((form) => {
    bindSubmit(form, () => form.dataset.zsMulti.split(',').filter(Boolean));
  });

  // Product page: option radios change the total and the items added.
  document.querySelectorAll('form[data-zs-buy]').forEach((form) => {
    const total = form.querySelector('[data-zs-total]');
    const stickyTotal = document.querySelector('[data-zs-sticky-total]');
    const selected = () => form.querySelector('input[name="zs_option"]:checked');
    form.querySelectorAll('input[name="zs_option"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (total) total.textContent = radio.dataset.total;
        if (stickyTotal) stickyTotal.textContent = radio.dataset.total;
      });
    });
    bindSubmit(form, () => {
      const option = selected();
      return option ? option.dataset.ids.split(',').filter(Boolean) : [form.querySelector('input[name="id"]').value];
    });

    const sticky = document.querySelector('[data-zs-sticky]');
    const stickyAdd = document.querySelector('[data-zs-sticky-add]');
    if (sticky && stickyAdd && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      const observer = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
      observer.observe(form);
      stickyAdd.addEventListener('click', () => form.requestSubmit());
    }
  });

  // Gallery thumbnails.
  document.querySelectorAll('[data-zs-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-zs-gallery-main]');
    gallery.querySelectorAll('.zs-gallery__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = thumb.dataset.src;
        gallery.querySelectorAll('.zs-gallery__thumb').forEach((t) => t.removeAttribute('aria-current'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  // Cart: checkout button stays visibly inactive until both consents are ticked.
  document.querySelectorAll('form[data-zs-checkout]').forEach((form) => {
    const boxes = form.querySelectorAll('[data-zs-consent]');
    const button = form.querySelector('[data-zs-checkout-btn]');
    const hint = form.querySelector('[data-zs-consent-hint]');
    const update = () => {
      const ok = Array.from(boxes).every((box) => box.checked);
      button.classList.toggle('is-locked', !ok);
      button.setAttribute('aria-disabled', String(!ok));
      if (hint) hint.hidden = ok;
    };
    boxes.forEach((box) => box.addEventListener('change', update));
    form.addEventListener('submit', (event) => {
      const missing = Array.from(boxes).find((box) => !box.checked);
      if (missing) {
        event.preventDefault();
        if (hint) hint.hidden = false;
        missing.reportValidity();
      }
    });
    update();
  });
})();
